// context/TransferFlowContext.jsx
import { createContext, useContext, useState, useEffect } from "react";

const TransferFlowContext = createContext(null);
const STORAGE_KEY = "blupay:activeTransferId";

export function TransferFlowProvider({ children }) {
  const [recipientId, setRecipientId] = useState(null);
  const [transferId, setTransferId] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) || null
  );
  const [quote, setQuote] = useState(null); // full quote object from createQuoteAsync

  useEffect(() => {
    if (transferId) sessionStorage.setItem(STORAGE_KEY, transferId);
    else sessionStorage.removeItem(STORAGE_KEY);
  }, [transferId]);

  const reset = () => {
    setRecipientId(null);
    setTransferId(null);
    setQuote(null);
  };

  return (
    <TransferFlowContext.Provider
      value={{ recipientId, setRecipientId, transferId, setTransferId, quote, setQuote, reset }}
    >
      {children}
    </TransferFlowContext.Provider>
  );
}

export const useTransferFlow = () => useContext(TransferFlowContext);